var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTune(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_571_1988",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_571_1988",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAABc0lEQVR4nO3YvS8EQRjH8dFwCtGp/AMKHAkhVyjICWqJBqWKEJWKP0GhECHU6rtGIUo9rZeKROMEhcZXJpbMTfbszl32ZeT5JNvtc/P89uZ2co9SQgghhGeAArAKnAA7QK/yNMQl9Z6B/iQW2wBeSNeZ1cN1yD1vwHrcEG0ZhNBqVh+VOPdFhamSviurB3v7/ai47uMyMJ/AtaifakiDS1YPcyG1M0C7ygtgGDgH3oPfQl0IIYQQf50zU0AJ6FQ+AsaBR+MguwdGVR4BReAIOA25nkJOZR2mYNQvNKht9ToGhlyC6MZclYz6FZJz+1+C3LgEGQQOHbbWXYpbqxg7SETIMeDBCjGiPH79Tgav399vQgghROaAbuAgmCLqc2cP6MrinJhucexzETWTAgYcP3MW6MjLgK7PWGezifqqS5AkR6ZlY53lJupreRhifwA9xjrbjvWvwJpKE7BlNfGpH5DyEd//6/eBXWAi636EEEII1cAX1N9xmRf+FeAAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTune);
export default __webpack_public_path__ + "static/media/Tune.185ff46c30ae2975764c93712004138f.svg";
export { ForwardRef as ReactComponent };